import React, { FC, MouseEventHandler, ReactElement, ReactNode } from 'react'
import { Box, BoxProps, Button, Flex, Heading, Spacer } from '@ritualco/jutsu'
import { useContent } from 'lib/content/react'

export interface EditableSectionProps extends BoxProps {
  action?: ReactNode
  onEditClick?: MouseEventHandler
  icon?: React.ReactElement
  showDivider?: boolean
}

export interface EditableDefinitionProps extends BoxProps {
  isReadOnly?: boolean
}

const borderStyle = '1px solid'

export const EditableSection: FC<EditableSectionProps> = ({
  title,
  action,
  onEditClick,
  children,
  icon,
  showDivider = false,
  ...props
}) => {
  const { formatMessage } = useContent()
  const dividerProps = {
    borderBottom: borderStyle,
    borderColor: 'grayscale.quinary',
  }
  return (
    <Box {...props}>
      <Flex align="center" {...(showDivider && dividerProps)} py={2} pl={2}>
        <Heading fontSize="large" fontWeight="medium" as="h3">
          {title}
        </Heading>
        <Spacer />
        {!!action ? (
          action
        ) : (
          <Button
            variant="outline"
            colorScheme="transparent"
            onClick={onEditClick}
            leftIcon={icon as ReactElement}
          >
            {formatMessage({ id: 'pmportal.global.actionEdit' })}
          </Button>
        )}
      </Flex>
      {children}
    </Box>
  )
}

export const EditableSectionRow: FC<BoxProps> = props => (
  <Box
    py="3"
    pl="2"
    borderTop={borderStyle}
    borderColor="grayscale.quinary"
    {...props}
  />
)

export const EditableSectionTermRow: FC<BoxProps> = props => (
  <EditableSectionRow
    display="flex"
    justifyContent="space-between"
    {...props}
  />
)

export const EditableSectionTerm: FC<BoxProps> = props => (
  <Box
    as="dt"
    fontWeight="normal"
    fontSize="small"
    color="grayscale.secondary"
    {...props}
  />
)

export const EditableSectionValue: FC<EditableDefinitionProps> = ({
  isReadOnly,
  ...props
}) => (
  <Box
    as="dd"
    fontSize="small"
    color={isReadOnly ? 'grayscale.secondary' : 'grayscale.primary'}
    textAlign="right"
    {...props}
  />
)
